import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getCompanies, getScoringForCompany } from "../WebKalkulator/modules/actions";

const mapStateToProps = (state) => ({
  companies: state.clientsReducer.companies,
  scoring: state.clientsReducer.scoring,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getCompanies,
      getScoringForCompany
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
